<template>
  <div class="rodape-recomendados">
    <span class="rodape-recomendados__eyebrow">Precisa de mais uma ajuda?</span>
    <RodapeRecomendadoItem
      v-for="item in itens"
      :key="item.titulo"
      :icon="item.icon"
      :titulo="item.titulo"
      :descricao="item.descricao"
      :href="item.href"
      :data-ua="item.dataUa"
    />
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

import HeadsetIcon from '~icons/ic/outline-headset-mic';
import LightbulbIcon from '~icons/ic/outline-lightbulb';

import RodapeRecomendadoItem from '@shared/rodape/components/RodapeRecomendadoItem/RodapeRecomendadoItem.vue';

interface RecomendacaoItem {
  icon: Component;
  titulo: string;
  descricao: string;
  href: string;
  dataUa: string;
}

const itens: RecomendacaoItem[] = [
  {
    icon: LightbulbIcon,
    titulo: 'Quero aprender',
    descricao: 'Conteúdo gratuito de educação financeira no acerto.blog',
    href: appSettings.VUE_APP_URL_BLOG,
    dataUa: 'click-nav-rodape-blog',
  },
  {
    icon: HeadsetIcon,
    titulo: 'Central de ajuda',
    descricao: 'Ficou com alguma dúvida? Encontre a resposta para a sua pergunta',
    href: appSettings.VUE_APP_URL_AJUDA,
    dataUa: 'click-nav-rodape-ajuda',
  },
];
</script>

<style scoped lang="scss">
@use "@/assets/styles/vars" as *;

.rodape-recomendados {
  display: flex;
  flex-direction: column;
  gap: $space-xxs;
}

.rodape-recomendados__eyebrow {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-77, #777);
}
</style>
